import { render, staticRenderFns } from "./CompanyPennylaneSync.vue?vue&type=template&id=66a54843&scoped=true&"
import script from "./CompanyPennylaneSync.vue?vue&type=script&lang=js&"
export * from "./CompanyPennylaneSync.vue?vue&type=script&lang=js&"
import style0 from "./CompanyPennylaneSync.vue?vue&type=style&index=0&id=66a54843&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a54843",
  null
  
)

export default component.exports